import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'

import { useSchedulerCalendar } from './provider'

export const MonthSelect = () => {
	const { currentDate, locale, setCurrentDate } = useSchedulerCalendar()

	const year = currentDate.getFullYear()
	const month = currentDate.getMonth()

	return (
		<Select
			value={String(month)}
			onValueChange={(value) => {
				const nextMonth = Number.parseInt(value, 10)
				setCurrentDate(new Date(year, nextMonth, 1, currentDate.getHours()))
			}}
		>
			<SelectTrigger
				inputSize='sm'
				className='w-[120px] rounded-r-none border-r-0 pr-2 capitalize'
			>
				<SelectValue />
			</SelectTrigger>

			<SelectContent>
				{Array.from({ length: 12 }).map((_, index) => {
					const monthValue = String(index)
					return (
						<SelectItem
							key={monthValue}
							value={monthValue}
							className='capitalize'
						>
							{dateTimeUtils(new Date(year, index, 1))
								.locale(locale)
								.format('MMMM')}
						</SelectItem>
					)
				})}
			</SelectContent>
		</Select>
	)
}
